import { useEffect, useRef } from 'react';
import { useVisitorData } from '@fingerprint/react';

import { User } from '@cast/types';

import { useSetFingerprintMutation } from '../api/useSetFingerprintMutation';
import { shouldEnableFingerprint } from '../auth.state';

export const useSetFingerprint = (user: User) => {
  const { getData } = useVisitorData({ immediate: false });
  const { mutate } = useSetFingerprintMutation();
  const hasFired = useRef(false);

  useEffect(() => {
    const fetchVisitorData = async () => {
      if (hasFired.current || !shouldEnableFingerprint(user)) {
        return;
      }

      hasFired.current = true;

      try {
        const data = await getData();
        mutate(data.event_id);
      } catch {
        // Silently ignore errors to avoid blocking user interactions
      }
    };

    fetchVisitorData();
  }, [getData, mutate, user]);
};
